export const environment = {
  name: 'staging',
  production: false,
  uat: false,
  staging: true,
  development: false,
  baseUrl: 'https://stg-agnr-api.tracwater.online', // Sensorwise Develop Server
  portalId: '6a6aca5d7efe74d1d36eb17b',
  portalTypeId: '6895970418f8a8985a2aebe2'
};
